import React, { useCallback, memo } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { noop } from 'lodash-es';
import { SELECTION_TYPE } from 'site-modules/canvas/constants/canvas';
import { ThinkingText } from 'site-modules/canvas/components/chat-messages/ai-message/thinking-text/thinking-text';
import { CanvasLoader } from 'site-modules/canvas/components/canvas-loader/canvas-loader';
import { useStartMessages } from 'site-modules/canvas/hooks/use-start-messages';

import './start-screen-suggested-messages.scss';

const MESSAGES_NUMBER = 3;
const SUGGESTED_MESSAGES = [
  {
    classes: 'bg-green-100',
  },
  {
    classes: 'bg-blue-100',
  },
  {
    classes: 'bg-orange-100',
  },
];

export const StartScreenSuggestedMessages = memo(({ startMessage = null, className = null, onSubmit = noop }) => {
  const { isThinking, suggestedMessages } = useStartMessages(startMessage);

  const onMessageClick = useCallback(
    message => () => {
      onSubmit(message, { selectionType: SELECTION_TYPE.STARTER_MESSAGE });
    },
    [onSubmit]
  );

  if (isThinking) {
    return (
      <div className="start-screen-thinking d-flex align-items-start">
        <div className="d-flex align-items-center gap-0_75 text-cool-gray-10">
          <CanvasLoader />
          <ThinkingText />
        </div>
      </div>
    );
  }

  return (
    !!suggestedMessages && (
      <div className={classnames('start-screen-suggested-messages pos-r', className)}>
        <h2 className="text-cool-gray-50 size-12 fw-bold mb-1">NEED A STARTER?</h2>
        <ul className={classnames('list-unstyled w-100 d-flex flex-column gap-0_75', className)}>
          {suggestedMessages
            ?.split(/\s*,\s*/)
            .slice(0, MESSAGES_NUMBER)
            .map((message, index) => (
              <li key={message}>
                <button
                  className="message-button d-flex align-items-center justify-content-center text-transform-none text-start bg-white text-cool-gray-30 gap-0_75 fw-bold rounded-100 pe-1_75 py-0_5 ps-0_5"
                  onClick={onMessageClick(message)}
                >
                  <span
                    className={classnames(
                      'icon-container rounded-circle d-flex align-items-center justify-content-center flex-shrink-0',
                      SUGGESTED_MESSAGES[index]?.classes
                    )}
                  >
                    <i className="icon text-cool-gray-50 size-20 icon-search2" aria-hidden />
                  </span>
                  {message}
                </button>
              </li>
            ))}
        </ul>
      </div>
    )
  );
});

StartScreenSuggestedMessages.propTypes = {
  className: PropTypes.string,
  onSubmit: PropTypes.func,
  startMessage: PropTypes.oneOfType([
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      text: PropTypes.string,
    }),
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      userText: PropTypes.string,
      responsePromise: PropTypes.instanceOf(Promise),
      generatedResponseId: PropTypes.string,
      isCanceled: PropTypes.bool,
    }),
  ]),
};
